import styled from '../styles/theme'
import Button from 'react-bootstrap/Button'

export const IconButton = styled(Button)`
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;

  svg {
    margin-right: 0.5rem;
    position: relative;
    top: -3px;
  }
`
